import { getStripeDate } from "../../../../utils/format-stripe-date";
import { formatNumber } from "../../../../utils/format-sub";

const RECENT_LIMIT = 5;

/**
 * The PUSH/PRESS Payouts tab (§5.10). Payouts are account-level — one
 * transfer covers both products — so the full history and reconciliation
 * live under All. Hiding the tab here would read as a missing feature and
 * "where are my Stripe payouts" gets asked from whichever tab you happen to
 * be on, so it carries the two things that need no product split: when the
 * next payout lands, and what recently landed.
 */
const PayoutsPointer = ({
  payouts = [],
  nextPayout = null,
  currency = "usd",
  t,
}) => {
  const recent = payouts.slice(0, RECENT_LIMIT);
  const fmt = (stamp) => {
    if (!stamp) return "—";
    const { day, month, year } = getStripeDate(stamp);
    return `${month} ${day}, ${year}`;
  };

  return (
    <div className="payouts-pointer">
      <p className="payouts-pointer__reason">
        {t("income.payouts.pointerReason")}
      </p>

      {nextPayout && (
        <p className="payouts-pointer__next my-4">
          {t("income.payouts.nextExpected", {
            date: fmt(Math.floor(new Date(nextPayout).getTime() / 1000)),
          })}
        </p>
      )}

      <h4>{t("income.payouts.recent")}</h4>
      {recent.length ? (
        <ul className="payouts-pointer__list">
          {recent.map((payout) => (
            <li key={payout.id}>
              <span>
                {formatNumber(payout.amount, payout.currency || currency)}
              </span>
              <span>{fmt(payout.arrivalDate)}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p>{t("income.payouts.empty")}</p>
      )}

      <a
        href="/coaching-portal/income?context=all&tab=payouts"
        data-button-type="secondary"
        role="button"
        className="w-fit"
      >
        {t("income.payouts.seeAll")}
      </a>
    </div>
  );
};

export default PayoutsPointer;
